import { useState, useCallback } from 'react';

export interface UsePaginationReturn {
  page: number;
  limit: number;
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
  resetPage: () => void;
}

export function usePagination(initialLimit = 10): UsePaginationReturn {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(initialLimit);

  const resetPage = useCallback(() => setPage(1), []);

  return { page, limit, setPage, setLimit, resetPage };
}
